const setMode = (mode) => {
  return {
    type: "SET_MODE",
    payload: mode,
  };
};

const setColor = (color) => {
  return {
    type: "SET_COLOR",
    payload: color,
  };
};

const getTheme = () => {
  return {
    type: "GET_THEME",
  };
};

const setSideBarOpen = (bool) => {
  return {
    type: "SET_SIDEBAR_OPEN",
    payload: bool,
  };
};

const exportDefault = {
  setColor,
  setMode,
  getTheme,
  setSideBarOpen,
};

export default exportDefault;
